import PropTypes from 'prop-types';

import Empty from '@zenbusiness/zui/Empty';
import Text from '@zenbusiness/zui/Text';

function Pricing({ product }) {
  const amount = product?.pricing?.amount;

  // Note: Some products have a price of 0 which we do not want to display, so we need to check for the absence of a price.
  if (amount === 0) {
    return <Empty noAmount />;
  }

  return (
    <Text
      color="secondary"
      size="sm"
      weight="medium"
    >
      {product?.pricing?.formattedPricePerInterval}
    </Text>
  );
}

Pricing.propTypes = {
  product: PropTypes.shape({
    pricing: PropTypes.shape({
      amount: PropTypes.number,
      formattedPricePerInterval: PropTypes.string
    })
  })
};

export default Pricing;
